import request from '@/config/axios'

export interface MarketTemplateVO {
  id?: number
  sourceId?: number
  name?: string
  brief?: string
  keyword?: string
  activityKey?: number
  categoryKey?: number
  festivalKey?: number
  sceneKey?: number
  tradeId?: number
  coverUrl?: string
  previewGifUrl?: string
  demoLink?: string
  hotScore?: number
  status?: number
  sort?: number
}

export interface MarketTemplatePageQuery {
  pageNo?: number
  pageSize?: number
  keyword?: string
  activityKey?: number
  categoryKey?: number
  festivalKey?: number
  sceneKey?: number
  tradeId?: number
  status?: number
}

export const getMarketTemplatePage = (params: MarketTemplatePageQuery) => {
  return request.get<{ list: MarketTemplateVO[]; total: number }>({ url: '/market/template/page', params })
}

export const getMarketTemplate = (id: number) => {
  return request.get<MarketTemplateVO>({ url: '/market/template/get', params: { id } })
}

export const updateMarketTemplateStatus = (id: number, status: number) => {
  return request.put({ url: '/market/template/update-status', params: { id, status } })
}

export const deleteMarketTemplate = (id: number) => {
  return request.delete({ url: '/market/template/delete', params: { id } })
}

export const createMarketTemplate = (data: MarketTemplateVO) => {
  return request.post({ url: '/market/template/create', data })
}

export const updateMarketTemplate = (data: MarketTemplateVO) => {
  return request.put({ url: '/market/template/update', data })
}
